import { Typography } from '@mui/material';
import { memo } from 'react';
import styled from 'styled-components';

import { BORDER_RADIUS, COLOR, COLOR_FUNCTION } from '@/globalStyles';

interface IBoxParams {
    title?: string | React.ReactNode;
    subtitle?: JSX.Element;
    children: React.ReactNode | React.ReactNode[];
    className?: string;
    headerRightPanel?: JSX.Element | null;
}

const Box = ({ title, subtitle, children, headerRightPanel, className }: IBoxParams) => {
    return (
        <div className={className}>
            {title || subtitle || headerRightPanel ? (
                <BoxHeader>
                    <LeftPanel>
                        {!!title && <Typography variant="box_title">{title}</Typography>}
                        {!!subtitle && <SubtitleSection>{subtitle}</SubtitleSection>}
                    </LeftPanel>
                    <RightPanel>{headerRightPanel}</RightPanel>
                </BoxHeader>
            ) : undefined}
            <BoxContent>{children}</BoxContent>
        </div>
    );
};

const SubtitleSection = styled.div`
    margin-top: 0.3rem;
`;
export const BoxHeader = styled.div`
    display: flex;
    border-bottom: 1px solid ${COLOR_FUNCTION.boxBorder};
    padding: 0.9375rem 0.625rem;
    justify-content: space-between;
    color: ${COLOR.eerieBlack};
`;
export const BoxContent = styled.div`
    padding: 0.625rem;
`;
const LeftPanel = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;
const RightPanel = styled.div`
    display: flex;
    align-items: center;
    color: ${COLOR.blue} !important;

    & svg {
        fill: ${COLOR.eerieBlack};
    }
`;
const Memoized = memo(Box);
const Styled = styled(Memoized)`
    display: flex;
    flex-direction: column;
    border: 1px solid ${COLOR_FUNCTION.boxBorder};
    border-radius: ${BORDER_RADIUS.small};
`;
export default Styled;
